import React from 'react';

import {Icon} from '@stubhub/bamboo';
import {getDisclosureIcon as getDisclosureIconName} from '@stubhub/disclosure-utils';

function getDisclosureIcon(disclosureId, disclosureType, props) {
  const selectedIcon = getDisclosureIconName(disclosureId, disclosureType);

  return <Icon name={selectedIcon} {...props} />;
}

export {getDisclosureIcon};
